
import React from "react";

import {links} from "../links";

export default function Header() {
    return (
        <header className="_header ">
            <span className="escribir">
                fran@dev: ~/ <span>welcome</span>
            </span>
            <nav>
                <ul>
                    {
                        links.map((link, index) => (
                            <li key={index}>
                                <a href={link.url}>{link.name}</a>
                            </li>
                        ))
                    }
                </ul>
            </nav>
        </header>
    )
}

